import { ANALYTIC_EVENTS } from 'ggApp/modules/gaAnalytics/constants';
import { pushDataLayer } from 'ggApp/modules/tracking/actions';
import { adaptReduxStorePayloadToGTMPayload } from '../utils/adapters';

export const registerNewCookiePolicy = () => {
    const eventPayload = {
        event: ANALYTIC_EVENTS.gtmEvent,
        eventCategory: 'new_cookie_consent',
        eventAction: 'impression',
        eventLabel: 'impression',
    };
    pushDataLayer(eventPayload);
};

export const registerAcceptAllCookies = () => {
    const eventPayload = {
        event: ANALYTIC_EVENTS.gtmEvent,
        eventCategory: 'new_cookie_consent',
        eventAction: 'acceptAll',
        eventLabel: {
            'marketing-cookie-consent': true,
            'preference-cookie-consent': true,
            'statistics-cookie-consent': true,
        },
    };
    pushDataLayer(eventPayload);
};

export const registerCookiePreferences = (reduxStorePreferences) => {
    const preferences = adaptReduxStorePayloadToGTMPayload(reduxStorePreferences);
    const eventPayload = {
        event: ANALYTIC_EVENTS.gtmEvent,
        eventCategory: 'new_cookie_consent',
        eventAction: 'customised_prefrence',
        eventLabel: preferences,
    };
    pushDataLayer(eventPayload);
};
